/**
 * No authentication provider for development/testing
 * WARNING: Only use in development environments
 */
import { getLogger } from '@qwickapps/logging';
const log = getLogger('QwickForge.MiddlewareClient.NoAuth');
export class NoAuthProvider {
    constructor() {
        log.warn('Using NoAuthProvider - authentication is disabled');
    }
    async getAuthHeaders() {
        return {
            'X-Dev-Mode': 'true',
        };
    }
    hasCredentials() {
        return true;
    }
    getAuthType() {
        return 'none';
    }
    getIdentifier() {
        return 'dev-mode';
    }
}
//# sourceMappingURL=NoAuthProvider.js.map